import React, { useState } from 'react';
import { LockKeyhole, Loader2 } from 'lucide-react';
import { adminApi, apiError, setAdminCsrf } from '../lib/adminApi';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const submit = async event => {
    event.preventDefault(); setLoading(true); setError('');
    try {
      const { data } = await adminApi.post('/admin/auth/login', { email, password });
      setAdminCsrf(data.csrfToken); setPassword(''); onLogin(data);
    } catch (err) { setError(apiError(err)); } finally { setLoading(false); }
  };
  return <main className="min-h-screen bg-gray-50 py-16 px-4">
    <div className="max-w-md mx-auto">
      <LockKeyhole className="w-9 h-9 text-[#a78242] mb-6" aria-hidden="true" />
      <h1 className="text-4xl font-serif mb-3" data-testid="admin-login-title">Administracija</h1>
      <p className="text-gray-600 mb-8 text-sm" data-testid="admin-login-brand">MAXLIGHT HRVATSKA</p>
      <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
        <div><Label htmlFor="admin-email">E-mail</Label><Input id="admin-email" type="email" autoComplete="username" required value={email} onChange={e => setEmail(e.target.value)} className="mt-2 bg-white" data-testid="admin-login-email" /></div>
        <div><Label htmlFor="admin-password">Administratorska lozinka</Label><Input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={e => setPassword(e.target.value)} className="mt-2 bg-white" data-testid="admin-login-password" /></div>
        {error && <p role="alert" className="text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <Button type="submit" disabled={loading} className="w-full" data-testid="admin-login-submit">{loading && <Loader2 className="animate-spin" size={16} />}Prijava</Button>
      </form>
    </div>
  </main>;
};